import Page, { getServerSideProps as compGetServerSideProps } from 'components/pages/Article';

export const getServerSideProps = compGetServerSideProps;
export default Page;
